(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('EditorStructureAddPartImportController', EditorStructureAddPartImportController);

    EditorStructureAddPartImportController.$inject = ['$uibModalInstance', '$scope'];

    function EditorStructureAddPartImportController($uibModalInstance, $scope) {
        var vm = this;
        var confirmed = false;

        vm.fields = [
            { key: 'front', label: '正面图', required: true },
            { key: 'back', label: '反面图(可选)' },
            { key: 'cutline', label: '刀线图(可选)' },
            { key: 'whiteink', label: '白墨图(可选)' }
        ];
        vm.images = { front: null, back: null, cutline: null, whiteink: null };

        vm.canImport = function () {
            return !!vm.images.front;
        };

        $scope.onFileSelected = function (key, file) {
            if (!file) {
                return;
            }
            if (vm.images[key]) {
                URL.revokeObjectURL(vm.images[key].url);
            }
            var url = URL.createObjectURL(file);
            var image = { url: url, name: file.name, width: 0, height: 0 };
            // 读取图片原始宽高，用于按宽高比初始化部件尺寸
            var probe = new Image();
            probe.onload = function () {
                image.width = probe.naturalWidth || probe.width;
                image.height = probe.naturalHeight || probe.height;
            };
            probe.src = url;
            vm.images[key] = image;
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.confirm = function () {
            if (!vm.canImport()) {
                return;
            }
            confirmed = true;
            $uibModalInstance.close({
                front: exportImage(vm.images.front),
                back: exportImage(vm.images.back),
                cutline: exportImage(vm.images.cutline),
                whiteink: exportImage(vm.images.whiteink)
            });
        };

        $scope.$on('$destroy', function () {
            if (!confirmed) {
                releaseImages();
            }
        });

        function exportImage(image) {
            return image ? { url: image.url, name: image.name, width: image.width, height: image.height } : null;
        }

        function releaseImages() {
            angular.forEach(vm.images, function (image) {
                if (image) {
                    URL.revokeObjectURL(image.url);
                }
            });
        }
    }
})();
